import logger from "./logging";

const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
    dateStyle: "short",
    timeStyle: "short",
});

/**
 * Formats the date in a human-readable way
 * @param dateValue expects a date or a string in the format ISO 8601 Instant
 */
export const formatDate = (dateValue: string | Date | undefined | null): string => {
    if (typeof dateValue === "string") {
        dateValue = new Date(dateValue);
    }

    if (dateValue instanceof Date) {
        const formatted = dateFormatter.format(dateValue);
        if (navigator.language.startsWith("de")) {
            return `${formatted} Uhr`;
        }
        return formatted;
    }
    if (dateValue == null) {
        return "-";
    }

    logger.error("unknown date type: ", dateValue);
    return "[unknown]";
};
